<template>
  <v-menu bottom left offset-y min-width="220">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        small
        v-on="on"
        v-bind="attrs"
        :aria-label="`Actions for ${mailbox.email}`"
        @click.native.stop
      >
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <!-- Item height is set here because a dense list still leaves a menu this
         short looking airy; 40px is the same figure KvmServiceView uses.
         Every item opens a modal (AM-1106); Webmail is its own button. -->
    <v-list dense class="py-1">
      <v-list-item
        v-for="item in items"
        :key="item.action"
        style="min-height: 40px;"
        @click="emit(item.action)"
      >
        <v-list-item-icon class="mr-3 my-2">
          <v-icon small aria-hidden="true">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
      <v-divider class="my-1"></v-divider>
      <v-list-item style="min-height: 40px;" @click="emit('delete')">
        <v-list-item-icon class="mr-3 my-2">
          <v-icon small color="red" aria-hidden="true">mdi-trash-can-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="red--text">Delete</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
const ITEMS = [
  { action: 'password', title: 'Change Password', icon: 'mdi-lock-outline' },
  { action: 'settings', title: 'Settings', icon: 'mdi-settings-outline' },
  { action: 'forwarder', title: 'Create Forwarder', icon: 'mdi-email-send-outline' },
  { action: 'alias', title: 'Create Alias', icon: 'mdi-at' },
  { action: 'autoreply', title: 'Create Automatic Reply', icon: 'mdi-reply-outline' },
  { action: 'catchall', title: 'Create Catch-all', icon: 'mdi-inbox-arrow-down' },
]

export default {
  name: 'MailboxActionsMenu',
  props: {
    mailbox: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      items: ITEMS,
    }
  },
  methods: {
    emit (action) {
      this.$emit('action', { action, mailbox: this.mailbox })
    },
  },
}
</script>
